import { setPath } from 'myredux/globalSlice';
import { getStore, getThunkDispatch } from 'myredux/store';
import { createMessage, createNotification, isUndefined } from 'utils/commonUtils';
import { logout } from 'myredux/loginSlice';

import axios from 'axios';

const instance = axios.create({
    //baseURL: 'http://192.168.0.254:5000/',
    //baseURL: 'https://test.be.bookzilla.cz',
    baseURL: 'https://be.bookzilla.cz',
});

const WHITELIST: String[] = ['/notification', '/workingHour', '/branchEmployee', '/employeeService', '/prices', '/for-select', '/detail', '/report'];
const GET_WHITELIST: String[] = ['/reservation/next-reservation', '/reservation/all/unconfirmed', '/reservation/customer'];
const OTHER_WHITELIST: String[] = [
    '/company',
    '/customer',
    '/term',
    '/category',
    '/branch',
    '/employee',
    '/product',
    '/reservation/create',
    '/reservation/bulk',
    '/bill/',
];

const checkWhiteList = (error: any) => {
    const url = error.config?.url;
    const method = error.config?.method?.toUpperCase();
    if (
        !!url &&
        !!method &&
        (WHITELIST.some((pattern) => url.includes(pattern)) ||
            (method === 'GET' && GET_WHITELIST.some((pattern) => url.includes(pattern))) ||
            (method !== 'GET' && OTHER_WHITELIST.some((pattern) => url.includes(pattern))))
    ) {
        createNotification('error', 'Systém se zasekl. Dej mu druhou šanci, nebo povolej technickou posádku, než se to ztratí v černé díře.', 'Omlouváme se');
    } else {
        getThunkDispatch()(setPath('/secured/500'));
    }
};

instance.interceptors.request.use((request) => {
    const session = getStore().getState()?.login;
    const branchId = getStore().getState().global.selectedBranchId;
    const token = session.token;
    const expirationDate = typeof session?.expirationDate === 'string' ? Date.parse(session?.expirationDate) : session?.expirationDate;

    if (expirationDate !== undefined && expirationDate < new Date() && !isUndefined(token)) {
        return Promise.reject({ data: undefined, status: 'error', statusCode: 666 });
    } else if (!isUndefined(token) && expirationDate !== undefined && expirationDate > new Date()) {
        request.headers.setAuthorization('Bearer ' + token);
        request.headers.set('X-Selected-Branch-Id', branchId);
    }
    return request;
});

instance.interceptors.response.use(
    (response) => {
        if (response.data.statusCode === 403) {
            getThunkDispatch()(setPath('/secured/403'));
        } else if (response.data.status === 'error') {
            checkWhiteList(response);
        }
        return response;
    },
    (error) => {
        // 666 custom error is logout
        if (error.statusCode === 666) {
            createMessage('info', 'Pro pokračování je nutné se znovu přihlásit.');
            getThunkDispatch()(logout());
            getThunkDispatch()(setPath('/'));
        } else {
            checkWhiteList(error);
        }
    },
);

export default instance;
